module.exports = __webpack_public_path__ + "static/media/24.8052ee56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/24.svg
// module id = 2816
// module chunks = 3